import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <header className="privacy-header">
        <a href="/" className="privacy-back">← Software Beyond Limits</a>
      </header>
      <main className="privacy-content">
        <h1>Privacy Policy</h1>
        <p className="privacy-updated">Last updated: March 20, 2026</p>

        <section className="privacy-intro">
          <p>
            <strong>Software Beyond Limits</strong> (“we,” “us,” or “our”) is
            the developer and publisher of the <strong>Instant Guide</strong>{' '}
            mobile application (“Instant Guide” or the “App”). On Google Play and
            the App Store, Instant Guide is listed under the developer name{' '}
            <strong>Software Beyond Limits</strong>, which is the legal entity
            responsible for this policy. This Privacy Policy describes how we
            handle information when you use Instant Guide.
          </p>
        </section>

        <section>
          <h2>1. Information We Collect</h2>
          <ul>
            <li>Account information (email, name) when you optionally sign in</li>
            <li>Location data to show nearby landmarks (only when you grant permission); this stays on your device and is never sent to our servers</li>
            <li>Crash and diagnostics data (e.g. device type, app version) to help us fix bugs and improve stability</li>
          </ul>
        </section>

        <section>
          <h2>2. Data Security</h2>
          <p>We implement industry-standard security measures to protect your data.</p>
        </section>

        <section>
          <h2>3. Your Rights</h2>
          <p>You may:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Request deletion of your account</li>
            <li>Opt out of marketing communications</li>
          </ul>
        </section>

        <section>
          <h2>4. Location Data</h2>
          <ul>
            <li>Location is used only on your device to show nearby landmarks; we never collect or receive your location on our servers</li>
            <li>We do not track your location when the app is closed</li>
            <li>You can disable location access in device settings</li>
          </ul>
        </section>

        <section>
          <h2>5. Third-Party Services</h2>
          <p>We use:</p>
          <ul>
            <li>Firebase (Google) for authentication, data storage, and crash reporting (Crashlytics)</li>
            <li>Apple/Google for payment processing</li>
          </ul>
        </section>

        <section>
          <h2>6. Changes to This Policy</h2>
          <p>We may update this policy periodically. We will notify you of significant changes.</p>
        </section>

        <section>
          <h2>7. Contact</h2>
          <p>
            For privacy questions about <strong>Instant Guide</strong>, contact{' '}
            <strong>Software Beyond Limits</strong> at{' '}
            <a href="mailto:softwarebeyondlimits@gmail.com">
              softwarebeyondlimits@gmail.com
            </a>
            .
          </p>
        </section>
      </main>
    </div>
  );
}


export default PrivacyPolicy;
